import React from "react";
import { useSelector } from "react-redux";
import { getFullName } from "utils";
import Button from "components/lib/Shared/Button";

const ApplicantDetails = (props) => {
  const { handleGoForward } = props;

  const currentUser = useSelector((state) => state.userSlice);
  const fields = [
    {
      name: "fullName",
      key: "Full Name",
      value: getFullName(currentUser?.names),
    },
    {
      name: "phoneNumber",
      key: "Phone Number",
      value: currentUser?.electronicAddress?.mobileNumber,
    },
    {
      name: "phoneNumber",
      key: "Phone Number",
      value: getFullName(currentUser?.names),
    },
    {
      name: "role",
      key: "Role",
      value: "Registrar",
    },
  ];
  return (
    <div>
      <div className="px-4 py-6 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md sm:p-6">
        <div className="flex flex-col space-y-2">
          {fields.map((field, index) => (
            <div key={`${field.key}_${index}`} className="flex flex-col">
              <div className="flex items-baseline justify-between">
                <label
                  htmlFor={field.name}
                  className="block mb-2 text-sm text-primary font-medium min-w-[13rem] w-52 whitespace-normal"
                >
                  {field.key}
                </label>

                <div
                  className={`bg-formInput flex w-[80%] justify-between relative`}
                >
                  {field.value}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-end mt-4">
        <Button
          type="button"
          onClick={handleGoForward}
          className="flex px-2 py-2 text-white button button-hover button-disabled button-outline button-focus bg-sflPrimary"
        >
          Next Page
        </Button>
      </div>
    </div>
  );
};

export default ApplicantDetails;
